import SupervisorAccount from '@mui/icons-material/SupervisorAccount';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function SupervisorAccountIcon(props: FixMe) {
  return <SupervisorAccount {...props} />;
}

export default SupervisorAccountIcon;
